import { CustomLabel } from "./CustomLabel";
import { Form } from "react-bootstrap";

interface VisualizacaoInputProps {
  id: string;
  label?: string;
  value: any;
}

const VisualizacaoInput: React.FC<VisualizacaoInputProps> = (props) => {
  return (
    <>
      {props.label && <CustomLabel>{props.label}</CustomLabel>}
      <Form.Control
        style={{ height: "38px", fontSize: "1rem" }}
        id={props.id}
        className="input-gc"
        type={"text"}
        readOnly
        value={props.value || ""}
        disabled
      />
    </>
  );
};

export default VisualizacaoInput;
